import React from "react";
import ReactDOM from "react-dom";
import dotenv from 'dotenv';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';

import App from "./App";

import { history, store } from "./redux/store";
import rootReducer from './redux/reducer';
import Firebase, { FirebaseContext } from "./components/firebase";
import { PageView } from './redux/config';
import HttpsRedirect from './redux/helper/react-https-redirect';
import * as serviceWorker from './serviceWorker';

import './fonts/ProximaNova-Regular.otf';
import './fonts/ProximaNova-SemiBold.otf';
import './fonts/ProximaNovaBold.otf';
import './fonts/ProximaNovaAltLight.otf';
import './fonts/ProximaNovaExtrabold.otf';

// Force CSSPlugin to not get dropped during build
gsap.registerPlugin(CSSPlugin);
dotenv.config();

const render = () => {
  // Facebook Pixel
  if (typeof window !== "undefined") {
    if (window.fbq != null) {
      window.fbq('track', 'PageView');
    }
  }
  //GA page log
  PageView();

  ReactDOM.render(
    <HttpsRedirect>
      <Provider store={store}>
        <BrowserRouter>
          <FirebaseContext.Provider value={new Firebase()}>
            <App history={history} />
          </FirebaseContext.Provider>
        </BrowserRouter>
      </Provider>
    </HttpsRedirect>,
    document.getElementById("app-root")
  );
};

render();

// Hot reloading
if (module.hot) {
  // Reload components
  module.hot.accept('./App', () => {
    render();
  })

  // Reload reducers
  module.hot.accept('./redux/reducer', () => {
    store.replaceReducer(rootReducer(history));
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
